import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
  import LoginView from '../views/LoginView.vue'
import MonitorPianificazioni from '@/components/MonitorPianificazioni.vue'
import HomeView from '@/views/HomeView.vue'
import MonitorCavaionPianificazioni from '@/components/MonitorCavaionPianificazioni.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/monitor',
    name: 'monitor',
    component: MonitorPianificazioni
  },
  {
    path: '/monitorcavaion',
    name: 'monitorcavaion',
    component: MonitorCavaionPianificazioni
  },
  {
    path: '/operatore',
    name: 'operatore',
    component: () => import('@/views/OperatoreView.vue'),
  },
  {
    path: '/operatorecavaion',
    name: 'operatorecavaion',
    component: () => import('@/views/OperatoreCavaionView.vue'),
  },
  {
    path: '/calendario',
    name: 'calendario',
    component: () => import('@/views/CalendarioView.vue'),
  },
  {
    path: '/calendariocavaion',
    name: 'calendariocavaion',
    component: () => import('@/views/CalendarioCavaionView.vue'),
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Guard per l'autenticazione
router.beforeEach((to, from, next) => {
  // Se la rotta richiede autenticazione
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Verifica se l'utente è già stato autenticato in questa sessione
    const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true'
    
    if (!isAuthenticated) {
      // Se non autenticato, reindirizza al login
      next({ name: 'login' })
    } else {
      // Se autenticato, procedi
      next()
    }
  } else {
    // Se la rotta non richiede autenticazione, procedi sempre
    next()
  }
})

export default router
